export const COMPANIES = [
  { id: "google",    name: "Google",         icon: "🔵", color: "from-blue-500/20 to-green-500/10",    border: "border-blue-500/20",    badge: "blue",    role: "SWE / L3–L5" },
  { id: "amazon",    name: "Amazon",         icon: "🟠", color: "from-orange-500/20 to-amber-500/10",  border: "border-orange-500/20",  badge: "amber",   role: "SDE / Leadership" },
  { id: "microsoft", name: "Microsoft",      icon: "🪟", color: "from-cyan-500/20 to-blue-500/10",     border: "border-cyan-500/20",    badge: "cyan",    role: "SWE / PM" },
  { id: "meta",      name: "Meta",           icon: "🔷", color: "from-indigo-500/20 to-blue-500/10",   border: "border-indigo-500/20",  badge: "indigo",  role: "E3–E5 Engineer" },
  { id: "apple",     name: "Apple",          icon: "🍎", color: "from-slate-500/20 to-gray-500/10",    border: "border-slate-500/20",   badge: "slate",   role: "ICT2–ICT4" },
  { id: "jpmorgan",  name: "JP Morgan",      icon: "🏦", color: "from-blue-600/20 to-slate-500/10",    border: "border-blue-600/20",    badge: "blue",    role: "SWE / Analyst" },
  { id: "tcs",       name: "TCS",            icon: "🇮🇳", color: "from-purple-500/20 to-indigo-500/10", border: "border-purple-500/20",  badge: "indigo",  role: "ASE / SE" },
  { id: "cognizant", name: "Cognizant",      icon: "🔵", color: "from-sky-500/20 to-cyan-500/10",      border: "border-sky-500/20",     badge: "cyan",    role: "Programmer Analyst" },
  { id: "infosys",   name: "Infosys",        icon: "🟢", color: "from-emerald-500/20 to-teal-500/10",  border: "border-emerald-500/20", badge: "green",   role: "SE / SSE" },
  { id: "wipro",     name: "Wipro",          icon: "💜", color: "from-violet-500/20 to-purple-500/10", border: "border-violet-500/20",  badge: "violet",  role: "Project Engineer" },
  { id: "accenture", name: "Accenture",      icon: "🟣", color: "from-fuchsia-500/20 to-pink-500/10",  border: "border-fuchsia-500/20", badge: "pink",    role: "ASE / SE" },
  { id: "netflix",   name: "Netflix",        icon: "🔴", color: "from-red-500/20 to-rose-500/10",      border: "border-red-500/20",     badge: "red",     role: "Senior SWE" },
  { id: "uber",      name: "Uber",           icon: "⚫", color: "from-gray-500/20 to-slate-500/10",    border: "border-gray-500/20",    badge: "slate",   role: "SWE / Backend" },
  { id: "goldman",   name: "Goldman Sachs",  icon: "🏛️", color: "from-yellow-500/20 to-amber-500/10",  border: "border-yellow-500/20",  badge: "amber",   role: "Analyst / Associate" },
  { id: "adobe",     name: "Adobe",          icon: "🔺", color: "from-red-600/20 to-orange-500/10",    border: "border-red-600/20",     badge: "red",     role: "MTS / SMTS" },
];

export const PRACTICE_QUESTIONS = {
  google: {
    Beginner: [
      "What is the difference between an array and a linked list? When would you use each?",
      "Explain what Big O notation means and give an example.",
      "What is a hash map and how does it work internally?",
      "What is recursion? Write a simple recursive function to calculate factorial.",
      "What is the difference between BFS and DFS? When would you use each?",
    ],
    Intermediate: [
      "Design a URL shortener like bit.ly. Walk through your data model and API design.",
      "How would you find the longest substring without repeating characters? What is the time complexity?",
      "Explain how a binary search tree works. What are its time complexities for insert, delete, and search?",
      "How would you detect a cycle in a linked list? Explain the Floyd's algorithm.",
      "What is dynamic programming? Solve the coin change problem using DP.",
    ],
    Advanced: [
      "Design Google Search's autocomplete system. How would you handle 1 billion queries per day?",
      "Explain how Google's MapReduce works and when you would use it.",
      "How would you design a distributed key-value store like Bigtable?",
      "Solve the 'Trapping Rain Water' problem and explain all possible approaches with trade-offs.",
      "How would you design a real-time collaborative document editor like Google Docs?",
    ],
  },
  amazon: {
    Beginner: [
      "Tell me about a time you delivered a project under a tight deadline. (Leadership Principle: Deliver Results)",
      "Describe a situation where you had to learn something new quickly to complete a task.",
      "What does 'Customer Obsession' mean to you? Give a real example.",
      "How do you prioritize tasks when you have multiple deadlines at the same time?",
      "Tell me about a mistake you made and what you learned from it.",
    ],
    Intermediate: [
      "Design Amazon's product recommendation system at a high level.",
      "Tell me about a time you disagreed with your manager and how you handled it. (Disagree and Commit)",
      "How would you design a rate limiter for Amazon's API Gateway?",
      "Describe a time you took ownership of a problem that wasn't your responsibility. (Ownership LP)",
      "How would you design Amazon's order tracking system to handle millions of orders per day?",
    ],
    Advanced: [
      "Design Amazon's warehouse fulfillment system — from order placement to delivery.",
      "Tell me about the most complex technical problem you've solved. Walk through your approach.",
      "How would you design a fraud detection system for Amazon Payments?",
      "Describe a time you raised the bar for your team. What did you do and what was the outcome?",
      "How would you architect a globally distributed inventory management system with eventual consistency?",
    ],
  },
  microsoft: {
    Beginner: [
      "What is object-oriented programming? Explain the four pillars with examples.",
      "What is the difference between a process and a thread?",
      "Explain what REST APIs are and the key HTTP methods.",
      "What is a deadlock? How can you prevent it?",
      "What is the difference between stack and heap memory?",
    ],
    Intermediate: [
      "Design a notification system for Microsoft Teams that handles millions of users.",
      "How would you implement a LRU cache? What data structures would you use?",
      "Explain the SOLID principles and give an example of each.",
      "How does garbage collection work in .NET/Java? What are the different GC strategies?",
      "How would you design a CI/CD pipeline for a large enterprise application?",
    ],
    Advanced: [
      "Design Azure's auto-scaling infrastructure for handling unpredictable traffic spikes.",
      "How would you design a distributed transaction system that maintains ACID properties?",
      "Explain the CAP theorem and how you would apply it when designing a distributed database.",
      "How would you design Microsoft OneDrive's file sync system for offline-first support?",
      "Describe how you would migrate a monolithic application to microservices with zero downtime.",
    ],
  },
  meta: {
    Beginner: [
      "What is the difference between SQL and NoSQL databases? When would you use each?",
      "Explain how a graph data structure works. What are adjacency lists vs adjacency matrices?",
      "What is a binary tree? What is the difference between a binary tree and a binary search tree?",
      "What does it mean for an algorithm to be 'greedy'? Give an example.",
      "What is the difference between synchronous and asynchronous programming?",
    ],
    Intermediate: [
      "Design Facebook's News Feed ranking system at a high level.",
      "How would you find all connected components in an undirected graph?",
      "Design a system to count the number of unique users who visited a page in the last 24 hours.",
      "How would you implement a distributed message queue like Facebook's internal messaging system?",
      "Explain how React's virtual DOM works and why it improves performance.",
    ],
    Advanced: [
      "Design Instagram's photo storage and delivery system at scale (billions of photos).",
      "How would you design Meta's real-time chat system (WhatsApp) for 2 billion users?",
      "Explain how you would build a content moderation system using ML at Facebook's scale.",
      "How would you design a social graph system that can answer 'degrees of separation' queries in real time?",
      "Design a system to detect and prevent coordinated inauthentic behavior on a social platform.",
    ],
  },
  apple: {
    Beginner: [
      "What is the difference between value types and reference types in Swift?",
      "Explain the MVC design pattern and how it applies to iOS development.",
      "What is ARC (Automatic Reference Counting) in Swift?",
      "What is the difference between a struct and a class in Swift?",
      "How does the iOS app lifecycle work? Describe the key states.",
    ],
    Intermediate: [
      "How would you design an offline-first iOS app that syncs with a backend?",
      "Explain memory management in Swift. How do you avoid retain cycles?",
      "How does Core Data work? When would you use it over other storage options?",
      "How would you optimize the performance of a slow UITableView with complex cells?",
      "Explain how Grand Central Dispatch (GCD) works and when you'd use it.",
    ],
    Advanced: [
      "Design Apple's iCloud sync system — how would you handle conflict resolution across devices?",
      "How would you build a privacy-preserving analytics system like Apple's differential privacy approach?",
      "Design a real-time collaborative feature for an iOS app with offline support.",
      "How would you architect a large-scale iOS app for maintainability and testability?",
      "Explain how you would implement end-to-end encryption in a messaging app on iOS.",
    ],
  },
  jpmorgan: {
    Beginner: [
      "What is the difference between a stock and a bond?",
      "Explain what a REST API is and how you would secure it in a financial application.",
      "What is SQL? Write a query to find the top 5 customers by total transaction amount.",
      "What is the difference between authentication and authorization?",
      "What is a microservice architecture and why is it used in banking systems?",
    ],
    Intermediate: [
      "How would you design a real-time fraud detection system for credit card transactions?",
      "Explain how you would implement a high-availability trading system with zero downtime.",
      "How would you design a database schema for a banking application handling millions of transactions?",
      "What is eventual consistency? How does it apply to distributed financial systems?",
      "How would you ensure data integrity in a payment processing system?",
    ],
    Advanced: [
      "Design a low-latency algorithmic trading platform that processes 1 million orders per second.",
      "How would you architect a risk management system that calculates portfolio risk in real time?",
      "Explain how you would build a regulatory compliance reporting system for a global bank.",
      "How would you design a distributed ledger system for inter-bank settlements?",
      "Describe how you would migrate a legacy COBOL banking system to a modern microservices architecture.",
    ],
  },
  tcs: {
    Beginner: [
      "What is the software development life cycle (SDLC)? Explain each phase.",
      "What is the difference between Agile and Waterfall methodologies?",
      "Explain what version control is and how Git works.",
      "What is a primary key and a foreign key in a relational database?",
      "What is the difference between unit testing and integration testing?",
    ],
    Intermediate: [
      "How would you approach debugging a production issue in a Java application?",
      "Explain the difference between monolithic and microservices architecture.",
      "How does Spring Boot simplify Java application development?",
      "What is the difference between SOAP and REST web services?",
      "How would you optimize a slow SQL query on a large database table?",
    ],
    Advanced: [
      "Design a scalable enterprise resource planning (ERP) system for a large manufacturing company.",
      "How would you architect a multi-tenant SaaS application for enterprise clients?",
      "Explain how you would implement a zero-downtime deployment strategy for a critical banking application.",
      "How would you design a data migration strategy for moving 10 years of legacy data to a new system?",
      "Describe your approach to building a highly available, fault-tolerant distributed system.",
    ],
  },
  cognizant: {
    Beginner: [
      "What is object-oriented programming? Give examples of encapsulation and inheritance.",
      "What is the difference between GET and POST HTTP methods?",
      "Explain what a database index is and why it improves query performance.",
      "What is the difference between checked and unchecked exceptions in Java?",
      "What is a design pattern? Name three common ones and their use cases.",
    ],
    Intermediate: [
      "How would you design a RESTful API for an e-commerce application?",
      "Explain the difference between optimistic and pessimistic locking in databases.",
      "How does the Spring MVC framework handle HTTP requests?",
      "What is Docker and how does containerization benefit application deployment?",
      "How would you implement caching in a high-traffic web application?",
    ],
    Advanced: [
      "Design a healthcare data management system that complies with HIPAA regulations.",
      "How would you architect a real-time data processing pipeline using Kafka and Spark?",
      "Explain how you would implement a service mesh for microservices communication.",
      "How would you design a disaster recovery strategy for a mission-critical application?",
      "Describe how you would build an AI-powered customer support system for a large enterprise.",
    ],
  },
  infosys: {
    Beginner: [
      "What is the difference between abstract classes and interfaces in Java?",
      "Explain what normalization is in databases. What are 1NF, 2NF, and 3NF?",
      "What is the difference between TCP and UDP protocols?",
      "What is a RESTful web service? What are its key constraints?",
      "Explain the concept of multithreading and when you would use it.",
    ],
    Intermediate: [
      "How would you design a library management system? Walk through the database schema and key APIs.",
      "Explain how Hibernate ORM works and what the N+1 query problem is.",
      "How would you implement role-based access control (RBAC) in a web application?",
      "What is the difference between horizontal and vertical scaling? When would you use each?",
      "How would you handle session management and security in a Java web application?",
    ],
    Advanced: [
      "Design a digital banking platform that handles 10 million customers across multiple countries.",
      "How would you architect a real-time analytics dashboard for monitoring business KPIs?",
      "Explain how you would implement event sourcing and CQRS in a complex domain.",
      "How would you design a global content delivery network (CDN) for a media streaming platform?",
      "Describe your approach to building a machine learning pipeline for predictive maintenance.",
    ],
  },
  wipro: {
    Beginner: [
      "What is cloud computing? Explain the difference between IaaS, PaaS, and SaaS.",
      "What is the difference between synchronous and asynchronous communication in microservices?",
      "Explain what CI/CD means and why it is important.",
      "What is the difference between a list and a set in Python?",
      "What is an API gateway and what role does it play in microservices?",
    ],
    Intermediate: [
      "How would you design a scalable notification service that supports email, SMS, and push notifications?",
      "Explain how Kubernetes manages containerized applications.",
      "How would you implement a distributed caching strategy using Redis?",
      "What is the saga pattern in microservices? When would you use it?",
      "How would you monitor and troubleshoot a production microservices application?",
    ],
    Advanced: [
      "Design a cloud-native application migration strategy for a legacy on-premise system.",
      "How would you architect a multi-region active-active deployment for a global application?",
      "Explain how you would implement a zero-trust security model for a cloud infrastructure.",
      "How would you design a data lake architecture for a large enterprise analytics platform?",
      "Describe how you would build a self-healing infrastructure using Kubernetes operators.",
    ],
  },
  accenture: {
    Beginner: [
      "What is digital transformation and why is it important for businesses?",
      "Explain the difference between waterfall and agile project management.",
      "What is a use case diagram? How is it used in software design?",
      "What is the difference between a web application and a mobile application?",
      "Explain what DevOps means and its key practices.",
    ],
    Intermediate: [
      "How would you approach a digital transformation project for a traditional retail company?",
      "Explain how you would design a customer 360 platform that integrates data from multiple sources.",
      "How would you implement a chatbot for customer service using NLP?",
      "What is Salesforce and how is it used in enterprise CRM implementations?",
      "How would you design a data governance framework for a large organization?",
    ],
    Advanced: [
      "Design an AI-powered supply chain optimization system for a global manufacturing company.",
      "How would you architect an enterprise integration platform that connects 50+ legacy systems?",
      "Explain how you would build a real-time personalization engine for a retail e-commerce platform.",
      "How would you design a blockchain-based solution for supply chain transparency?",
      "Describe your approach to building a cloud-first strategy for a Fortune 500 company.",
    ],
  },
  netflix: {
    Beginner: [
      "What is the difference between SQL and NoSQL? Which would you use for storing user watch history?",
      "Explain what CDN (Content Delivery Network) is and why Netflix uses it.",
      "What is the difference between encoding and encryption?",
      "What is a microservice? How does it differ from a monolith?",
      "Explain what A/B testing is and how it is used to improve a product.",
    ],
    Intermediate: [
      "How would you design Netflix's video recommendation system?",
      "Explain how Netflix's Chaos Engineering (Chaos Monkey) works and why it is valuable.",
      "How would you design a video streaming system that adapts quality based on network speed?",
      "How does Netflix handle millions of concurrent streams without downtime?",
      "How would you design a system to detect and prevent password sharing at scale?",
    ],
    Advanced: [
      "Design Netflix's global content delivery system that serves 200+ million subscribers.",
      "How would you architect Netflix's real-time data pipeline for personalization at scale?",
      "Explain how you would build a fault-tolerant video encoding pipeline for millions of titles.",
      "How would you design a multi-region active-active architecture for Netflix's API layer?",
      "Describe how Netflix uses machine learning for thumbnail personalization and its technical implementation.",
    ],
  },
  uber: {
    Beginner: [
      "What is geohashing and how is it used in location-based services?",
      "Explain the difference between a relational and a document database.",
      "What is a message queue? Why would you use one in a ride-sharing app?",
      "What is the difference between latency and throughput?",
      "Explain what WebSockets are and when you would use them over HTTP.",
    ],
    Intermediate: [
      "How would you design Uber's driver-rider matching algorithm?",
      "How would you implement surge pricing in real time based on supply and demand?",
      "Design a system to track the real-time location of millions of drivers simultaneously.",
      "How would you handle the 'thundering herd' problem in Uber's backend during peak hours?",
      "How would you design Uber's ETA prediction system?",
    ],
    Advanced: [
      "Design Uber's dispatch system that matches riders to drivers in under 1 second globally.",
      "How would you architect Uber's real-time map and routing system at global scale?",
      "Explain how you would build a fraud detection system for Uber's payment platform.",
      "How would you design a distributed tracing system for Uber's 4000+ microservices?",
      "Describe how you would build Uber's dynamic pricing model using real-time ML inference.",
    ],
  },
  goldman: {
    Beginner: [
      "What is the difference between equity and fixed income securities?",
      "Explain what a REST API is and how you would use it to fetch stock prices.",
      "What is the time complexity of quicksort? When does it degrade to O(n²)?",
      "What is the difference between a stack and a queue? Give a financial use case for each.",
      "What is SQL? Write a query to calculate the average trade volume per stock symbol.",
    ],
    Intermediate: [
      "How would you design a real-time market data feed system that handles 1 million price updates per second?",
      "Explain how you would implement a thread-safe order book for a trading system.",
      "How would you design a risk calculation engine that computes VaR (Value at Risk) in real time?",
      "What is the difference between OLTP and OLAP systems? How are they used in finance?",
      "How would you implement a distributed lock to prevent duplicate trade execution?",
    ],
    Advanced: [
      "Design a high-frequency trading system with sub-millisecond latency requirements.",
      "How would you architect a global trade settlement system that handles multi-currency transactions?",
      "Explain how you would build a real-time portfolio risk aggregation system across asset classes.",
      "How would you design a regulatory reporting system that generates MiFID II reports in real time?",
      "Describe how you would implement a machine learning model for credit risk scoring in production.",
    ],
  },
  adobe: {
    Beginner: [
      "What is the difference between raster and vector graphics?",
      "Explain what a REST API is and how Adobe's Creative Cloud APIs work.",
      "What is the difference between RGB and CMYK color models?",
      "What is a design system and why is it important for large-scale products?",
      "Explain what responsive design means and how CSS media queries work.",
    ],
    Intermediate: [
      "How would you design Adobe Photoshop's undo/redo system for complex operations?",
      "Explain how you would implement real-time collaboration in a document editor like Adobe XD.",
      "How would you design a PDF rendering engine that handles complex layouts efficiently?",
      "How would you optimize image processing algorithms for performance on large files?",
      "How would you design Adobe's asset management system for Creative Cloud libraries?",
    ],
    Advanced: [
      "Design Adobe's Firefly AI image generation system — from prompt to rendered image at scale.",
      "How would you architect Adobe's Document Cloud to handle billions of PDF operations per day?",
      "Explain how you would build a real-time collaborative design tool like Figma at Adobe's scale.",
      "How would you design a content intelligence system that auto-tags and categorizes millions of assets?",
      "Describe how you would implement a GPU-accelerated rendering pipeline for Adobe Premiere Pro.",
    ],
  },
};
